import { BaseDataModel } from "./base";

export interface RobotRaw {
	timestamp: number;
	azimuth: string;
	current_job_id: string;
	current_mission: string;
	east_velocity: string;
	north_velocity: string;
	up_velocity: string;
	expiration: number;
	hardware_throttle_report: string;
	header_frame_id: string;
	header_seq: number;
	header_stamp_nsecs: number;
	header_stamp_secs: number;
	height: string;
	latitude: string;
	longitude: string;
	mission_state: number;
	pitch: string;
	roll: string;
	seconds: string;
	status: string;
}

export class Robot extends BaseDataModel {
	name!: string;
	latitude!: number;
	longitude!: number;
	raw?: RobotRaw[];
}
